import { FIRE_DEPARTMENT_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Texas State Portal": {
    parameters: {
      linkUrls: ["https://www3.tceq.texas.gov/steers/index.cfm"],
      staffInputs: {
        fees: true,
        documentTypes: {
          receipt: true,
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    consolidated: "Once Per CN",
    state: "TX",
  },
  "Plano Fire-Rescue Portal": {
    parameters: {
      linkUrls: ["https://www.plano.gov/1632/Submit-Tier-II-Report"],
      staffInputs: {
        fees: false,
        documentTypes: {
          receipt: false,
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.TX.PLANO_FIRE_RESCUE,
          name: "Plano Fire-Rescue",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "TX",
    dependsOn: ["Prior Activity"],
  },
};
